import React from "react";
import "../styles.css";

const Footer = () => {
  return (
    <div
      className="f"
      // style={{
      //   backgroundColor: darkMode ? "black" : "White",
      //   color: darkMode && "white",
      // }}
    >
      <div className="f-auth">
        Copyright &copy; Sahil Pillania - {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default Footer;
